import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { AuthService } from '../../../auth/services/auth.service';
import { PrivacyState, Terms } from '../../interfaces/privacy-state.interface';
import { TermsStatus } from '../../interfaces/terms-status.enum';
import * as PrivacyActions from '../../state/actions/privacy.actions';
import {
  selectState,
  selectTerms,
} from '../../state/selectors/privacy.selector';

@Component({
    selector: 'pl-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: false
})
export class TermsOfUseComponent implements OnInit, OnDestroy {
  public isTermsAccepted = false;
  public checkAccepted = false;
  public termsHtmlContent = '';

  public privacySelector$ = new Observable<Terms[]>();
  public privacyState$ = new Observable<PrivacyState>();
  public currentTerm?: Terms;

  private readonly _subs: Subscription[] = [];

  constructor(
    private readonly store: Store,
    private readonly router: Router,
    private readonly _authService: AuthService
  ) {
    this.privacySelector$ = this.store.select(selectTerms);
    this.privacyState$ = this.store.select(selectState);
  }

  ngOnInit(): void {
    this._subs.push(
      this.privacySelector$.subscribe((terms) => {
        if (terms?.length) {
          this.currentTerm = terms[0];

          if (this.currentTerm.status === TermsStatus.ACCEPTED) {
            this._redirectToDashboard();
          }
        }
      })
    );

    this._subs.push(
      this.privacyState$.subscribe((state) => {
        if (!state.isLoading && state.success) {
          this._redirectToDashboard();
        }
      })
    );
  }

  public registerAccepted(): void {
    const latestVersion = this.currentTerm?.version ?? '';

    this.isTermsAccepted = true;
    this.store.dispatch(
      PrivacyActions.loadAcceptTerms({ version: latestVersion })
    );
  }

  private _redirectToDashboard(): void {
    this._authService.termIsAccepted = true;
    this.isTermsAccepted = true;
    this.router.navigate(['dashboard']);
  }

  ngOnDestroy() {
    for (const sub of this._subs) {
      sub.unsubscribe();
    }
  }
}
